module.exports = __webpack_public_path__ + "static/media/palm_to_palm.7c8074e9.svg";